module.exports = __webpack_public_path__ + "media/src/img/payment/heart-pink-24e86e5b1e125e74fca5bc45e71f9824.svg";